/* eslint-disable arrow-body-style */
import React, { useEffect, useRef } from 'react';
import {
  Icon, sanitize,
} from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';
import { analyticsConstants } from '../../../constants/analyticsConstants';

const ErrorPage = () => {
  const analyticsRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    analyticsRef.current?.click();
  }, []);
  return (
    <div
      id={analyticsConstants.ofiError}
      className="col-lg-8 col-sm-12 blade blade--vertical px-4"
      ref={analyticsRef}
    >
      <div className="blade__content mt-8">
        <Icon
          screenreader="Error icon"
          symbol="messageAlert64"
          type="svgfile"
        />
        <div className="mt-5">
          <h2
            className="mb-5"
            dangerouslySetInnerHTML={sanitize(content.error.errorTitle)}
          />
          <div dangerouslySetInnerHTML={sanitize(content.error.errorDescription)} />
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
